import React, { useState } from 'react';
import LogoIcon from '@medflex/components/stories/Logo/LogoIcon';
import Button from '@medflex/components/stories/Button';
import { useTranslation } from 'react-i18next';

const AppVersionModule = () => {
  const { t } = useTranslation('global', { keyPrefix: 'AppVersionModule' });
  const [updateAvailable, setUpdateAvailable] = useState(
    window.electron?.globals?.getUpdateAvailable?.(),
  );
  const [isLoading, setIsLoading] = useState(false);
  const clientVersion = window.electron?.globals?.getClientVersion?.();

  const handleCheckForUpdates = async () => {
    window.electron?.globals?.checkForUpdates?.();
    setIsLoading(true);
    setTimeout(() => {
      setUpdateAvailable(window.electron?.globals?.getUpdateAvailable?.());
      setIsLoading(false);
    }, 2000);
  };

  return (
    <div data-component="AppVersionModule">
      <h1 className="font-semibold text-lg mb-6">{t('title')}</h1>
      <div className="flex flex-row mb-6">
        <div className="p-2 rounded-lg border border-blue-100 bg-blue-50 w-fit shadow-md">
          <LogoIcon />
        </div>
        <div className="ml-6 content-center">
          <p>{t('subtitle')}</p>
          <p className="font-semibold">{clientVersion}</p>
        </div>
      </div>

      {updateAvailable ? (
        <p className="text-red-500 mb-4">{t('update_available')}</p>
      ) : (
        <>
          <p className="mb-4">{t('up_to_date')}</p>
          <Button
            type="button"
            kind="secondary:outline"
            isLoading={isLoading}
            onClick={handleCheckForUpdates}
          >
            {t('check_for_updates')}
          </Button>
        </>
      )}
    </div>
  );
};

export default AppVersionModule;
